export default "__VITE_ASSET__4b14c94a__"